
import { css } from 'lit';
export default css`
pc-image img{
    object-fit:cover;
  }
  pc-image img.has-right-radius{
    border-top-right-radius:300px;
    border-bottom-right-radius:300px;
    overflow:hidden;
  }
  pc-image img.rounded-full{
    border-radius:100%;
    aspect-ratio:1;
  }
  pc-image img.rounded-small{
    border-radius:8px;
  }
  pc-image .rounded-medium{
    border-radius:8px;
  }
  @media (min-width: 768px){
    pc-image .rounded-medium{
      border-radius:16px;
    }
  }
`;